import ApplicationStatusContainer from "./ApplicationStatusContainer";

export default ApplicationStatusContainer;
